const reactSelectStyles = {
    control: (style, { isDisabled }) => ({
        ...style,
        backgroundColor: isDisabled ? 'transparent' : null,
        border: 'none',
        boxShadow: 'none'
    }),
    singleValue: (style) => ({
        ...style,
        color: '#5a5a5a'
    }),
    valueContainer: (style) => ({
        ...style,
        paddingLeft: 20,
        outline: 'none',
        border: 'none',
        color: '#5a5a5a'
    }),
    option: (style, { isFocused, isSelected }) => {
        let backgroundColor = isSelected ? 'rgba(76, 87, 166, 0.05)' : 'transparent';
        return ({
            ...style,
            padding: '12px 20px',
            backgroundColor: isFocused ? '#4550a2' : backgroundColor,
            color: isFocused ? '#ffffff' : '#5a5a5a'
        });
    },
    indicatorSeparator: () => ({
        display: 'none'
    }),
    menuList: (style) => ({
        ...style,
        paddingTop: 0,
        paddingBottom: 0
    }),
    menu: (style) => ({
        ...style,
        marginTop: 2,
        borderRadius: 0
    }),
    indicatorsContainer: (style, { isDisabled }) => ({
        ...style,
        display: isDisabled ? 'none' : null
    }),
    input: (style) => ({
        ...style,
        marginLeft: 10,
    }),
    placeholder: (style) => ({
        ...style,
        marginLeft: 10,
        fontStyle: "oblique",
    }),
};

export {reactSelectStyles};


// WEBPACK FOOTER //
// ./src/Components/constants.ts